module.exports = __webpack_public_path__ + "img/robert-broermann.4784d4c9.jpg";